import * as React from 'react';
import { NumberContainer, PathItem, Root, LabelText } from './releasePath.styles';

export type ReleasePathSteps = 'upload' | 'qa' | 'details' | 'submit' | 'your_game' | 'review';

interface ReleasePathProps {
  step: ReleasePathSteps;
  showAllSteps?: boolean;
}

const ReleasePath: React.FunctionComponent<ReleasePathProps> = ({ step, showAllSteps = true }) => {
  return (
    <Root sx={{ my: 2 }}>
      <PathItem active={step === 'upload'}>
        <NumberContainer active={step === 'upload'}>1</NumberContainer>
        <LabelText>Upload</LabelText>
      </PathItem>

      <PathItem active={step === 'qa'}>
        <NumberContainer active={step === 'qa'}>2</NumberContainer>
        <LabelText>QA</LabelText>
      </PathItem>
      {showAllSteps && (
        <>
          <PathItem active={step === 'details'}>
            <NumberContainer active={step === 'details'}>3</NumberContainer>
            <LabelText>Details</LabelText>
          </PathItem>

          <PathItem active={step === 'submit'}>
            <NumberContainer active={step === 'submit'}>4</NumberContainer>
            <LabelText>Submit</LabelText>
          </PathItem>
        </>
      )}
    </Root>
  );
};

export default ReleasePath;
